import { ErrorMessageContents } from '../../helpers/hub'
import { Order } from '../order/types'
import { QuoteReliability } from '../securities/types'

export const popoutSecurity = (payload: number) =>
  ({
    type: 'depthofmarket.popout',
    payload
  } as const)
export type PopoutSecurityAction = ReturnType<typeof popoutSecurity>

export const closePopout = (payload: number) =>
  ({
    type: 'depthofmarket.closePopout',
    payload
  } as const)
export type ClosePopoutAction = ReturnType<typeof closePopout>

export const closeAllPopouts = () =>
  ({
    type: 'depthofmarket.closeAllPopouts'
  } as const)
export type CloseAllPopoutsAction = ReturnType<typeof closeAllPopouts>

export const updatePopouts = (previous: number, current: number) =>
  ({
    type: 'depthofmarket.updatePopouts',
    payload: { previous, current }
  } as const)
export type UpdatePopoutsAction = ReturnType<typeof updatePopouts>

export const markAsRestricted = (id: string) =>
  ({
    type: 'depthofmarket.markAsRestricted',
    payload: { id }
  } as const)
export type MarkAsRestrictedAction = ReturnType<typeof markAsRestricted>
export const markAsRestrictedSuccess = (errors: any) =>
  ({
    type: 'depthofmarket.markAsRestrictedSuccess',
    payload: errors
  } as const)
export type MarkAsRestrictedSuccessAction = ReturnType<
  typeof markAsRestrictedSuccess
>

export const markAsRestrictedFailure = (errors: ErrorMessageContents) =>
  ({
    type: 'depthofmarket.markAsRestrictedFailure',
    payload: errors
  } as const)
export type MarkAsRestrictedFailureAction = ReturnType<
  typeof markAsRestrictedFailure
>
export const markAsUnrestricted = (id: string) =>
  ({
    type: 'depthofmarket.markAsUnrestricted',
    payload: { id }
  } as const)
export type MarkAsUnrestrictedAction = ReturnType<typeof markAsUnrestricted>
export const markAsUnrestrictedSuccess = (errors: any) =>
  ({
    type: 'depthofmarket.markAsUnrestrictedSuccess',
    payload: errors
  } as const)
export type MarkAsUnrestrictedSuccessAction = ReturnType<
  typeof markAsUnrestrictedSuccess
>
export const markAsUnrestrictedFailure = (errors: ErrorMessageContents) =>
  ({
    type: 'depthofmarket.markAsUnrestrictedFailure',
    payload: errors
  } as const)
export type MarkAsUnrestrictedFailureAction = ReturnType<
  typeof markAsUnrestrictedFailure
>
export const forceCancel = (id: string) =>
  ({
    type: 'depthofmarket.forceCancel',
    payload: { id }
  } as const)
export type ForceCancelAction = ReturnType<typeof forceCancel>

export const forceCancelSuccess = (errors: any) =>
  ({
    type: 'depthofmarket.forceCancelSuccess',
    payload: errors
  } as const)
export type ForceCancelSuccessAction = ReturnType<typeof forceCancelSuccess>

export const forceCancelFailure = (errors: ErrorMessageContents) =>
  ({
    type: 'depthofmarket.forceCancelFailure',
    payload: errors
  } as const)
export type ForceCancelFailureAction = ReturnType<typeof forceCancelFailure>

export const setDomLimitExceeded = (overflow: boolean) =>
  ({
    type: 'depthofmarket.setDomLimitExceeded',
    payload: overflow
  } as const)
export type DOMLimitExceededAction = ReturnType<typeof setDomLimitExceeded>

export const setDomSecurityByQuery = (oldSecurityId: number, query: string) =>
  ({
    type: `depthofmarket.setDomSecurityByQuery`,
    payload: { oldSecurityId, query }
  } as const)
export type SetDomSecurityByQueryAction = ReturnType<
  typeof setDomSecurityByQuery
>

export const subscribeDepthForSecurity = (
  securityId: number,
  quoteReliability: QuoteReliability,
  callId: string
) =>
  ({
    type: 'depthofmarket.subscribeDepthForSecurity',
    payload: { securityId, quoteReliability, callId }
  } as const)
export type SubscribeDepthForSecurityAction = ReturnType<
  typeof subscribeDepthForSecurity
>

export const unsubscribeDepthForSecurity = (
  securityId: number,
  callId: string
) =>
  ({
    type: 'depthofmarket.unsubscribeDepthForSecurity',
    payload: { securityId, callId }
  } as const)
export type UnsubscribeDepthForSecurityAction = ReturnType<
  typeof unsubscribeDepthForSecurity
>

export const setDepthForSecurityFailed = (securityId: number, callId: string) =>
  ({
    type: 'depthofmarket.setDepthForSecurityFailed',
    payload: { securityId, callId }
  } as const)
export type SetDepthForSecurityFailedAction = ReturnType<
  typeof setDepthForSecurityFailed
>

export const setDepthForSecurity = (
  securityId: number,
  orders: Order[],
  callId: string
) =>
  ({
    type: 'depthofmarket.setDepthForSecurity',
    payload: { securityId, orders, callId }
  } as const)
export type SetDepthForSecurityAction = ReturnType<typeof setDepthForSecurity>

export type DepthOfMarketAction =
  | PopoutSecurityAction
  | ClosePopoutAction
  | CloseAllPopoutsAction
  | UpdatePopoutsAction
  | MarkAsRestrictedAction
  | MarkAsRestrictedSuccessAction
  | MarkAsRestrictedFailureAction
  | MarkAsUnrestrictedAction
  | MarkAsUnrestrictedSuccessAction
  | MarkAsUnrestrictedFailureAction
  | ForceCancelAction
  | ForceCancelSuccessAction
  | ForceCancelFailureAction
  | DOMLimitExceededAction
  | SetDomSecurityByQueryAction
  | SubscribeDepthForSecurityAction
  | UnsubscribeDepthForSecurityAction
  | SetDepthForSecurityAction
  | SetDepthForSecurityFailedAction
